import { ComputedRef } from 'vue';

export const MENU_ITEM_TYPES = {
  LINK: 'link',
  ROUTER_LINK: 'router_link',
  DIVIDER: 'divider'
} as const;

export interface BaseMenuItem {
  type: string;
}

export interface TextMenuItem extends BaseMenuItem {
  text: string;
  condition?: boolean | ComputedRef<boolean>;
  event?: string;
  eventParams?: Record<string, any>;
  showAIBetaBadge?: boolean;
}

export interface LinkMenuItem extends TextMenuItem {
  type: typeof MENU_ITEM_TYPES.LINK;
  href: string;
  target?: string;
  onClick?: () => Promise<void> | void;
  external?: boolean;
}

export interface RouterLinkMenuItem extends TextMenuItem {
  type: typeof MENU_ITEM_TYPES.ROUTER_LINK;
  to: string | Record<string, any>;
}

export interface DividerMenuItem extends BaseMenuItem {
  type: typeof MENU_ITEM_TYPES.DIVIDER;
}

export type MenuItem = LinkMenuItem | RouterLinkMenuItem | DividerMenuItem;

export function isRouterLinkMenuItem(item: MenuItem): item is RouterLinkMenuItem {
  return item.type === MENU_ITEM_TYPES.ROUTER_LINK;
}

export function isLinkMenuItem(item: MenuItem): item is LinkMenuItem {
  return item.type === MENU_ITEM_TYPES.LINK;
}

export function isDividerMenuItem(item: MenuItem): item is DividerMenuItem {
  return item.type === MENU_ITEM_TYPES.DIVIDER;
}

export function isMenuItemVisible(item: MenuItem): boolean {
  if (isDividerMenuItem(item) || item.condition === undefined) {
    return true;
  }
  if (typeof item.condition === 'boolean') {
    return item.condition;
  }
  return item.condition.value;
}
